import React, { Component } from "react";
import * as s from "./SaveToOfflineSidebar.module.scss";
import { inject, observer } from "mobx-react";
import { Icons } from "resource-centre-theme/src/libs/assets";
import {
  UIStore,
  UserStore,
  CacheStore,
} from "resource-centre-theme/src/stores";
import {
  truncate,
  stripHtmlFromString,
  parseSlugToText,
} from "resource-centre-theme/src/libs/utils";
import { ISingleWordpressDocument } from "resource-centre-theme/src/models";
import {
  P,
  Checkbox,
  DynamicImage,
} from "resource-centre-theme/src/views/shared/components";
import { tx } from "resource-centre-theme/src/libs/i18n";
import { DropdownItem } from "./DropdownItem";

interface Props {
  document: ISingleWordpressDocument;
  cacheStore?: CacheStore;
  hideDescription?: boolean;
}

interface State {
  copyLinkOverlayOpen: boolean;
  informationOverlayOpen: boolean;
}

@inject("cacheStore")
@observer
export class DocumentDropdownItem extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      copyLinkOverlayOpen: false,
      informationOverlayOpen: false,
    };
  }

  renderPDFItem = (item, key) => {
    const { cacheStore } = this.props;
    const {
      checkAllChildNodes,
      checkboxNodes,
      updateNodes,
      checkboxSelected,
    } = cacheStore;

    const { documentFile } = item;
    if (!documentFile) return;

    const { title, slug, id } = documentFile;
    const pdfItemClasses = [s.pdfItem, s.documentItemWrapper];
    if (checkboxSelected(id)) {
      pdfItemClasses.push(s.selected);
    }

    const checkboxOnChange = (e) => {
      const checkboxes = checkAllChildNodes(checkboxNodes, id, e);
      updateNodes(checkboxes);
    };
    return (
      <div key={slug + key} className={pdfItemClasses.join(" ")}>
        <div className={s.checkboxWrapper}>
          <Checkbox
            type="check"
            selected={checkboxSelected(id)}
            onChange={checkboxOnChange}
          />
        </div>
        <div className={s.documentWrapper}>
          <span className={s.title}>{title && parseSlugToText(title)}</span>
        </div>
      </div>
    );
  };

  renderDocumentTitleItem = () => {
    const { cacheStore, document, hideDescription } = this.props;
    const {
      checkAllChildNodes,
      checkboxNodes,
      updateNodes,
      checkboxSelected,
    } = cacheStore;
    const {
      title,
      documentThumbnail,
      documentFields,
      id,
      documentContentTypes,
    } = document;
    const { abstract, format, numberOfPages } = documentFields;
    const checkboxOnChange = (e) => {
      const checkboxes = checkAllChildNodes(checkboxNodes, id, e);
      updateNodes(checkboxes);
    };

    return (
      <div className={s.documentItemWrapper}>
        <div className={s.checkboxWrapper}>
          <Checkbox
            type="check"
            selected={checkboxSelected(id)}
            onChange={checkboxOnChange}
          />
        </div>
        <div className={s.imageWrapper}>
          <div className={s.imageContent}>
            <DynamicImage
              className={s.image}
              image={documentThumbnail?.image}
              size="thumbnail"
              alt="card-image"
            />
          </div>
        </div>
        <div className={s.documentWrapper}>
          <h6 className={s.contentTypes}>
            {documentContentTypes?.contentTypes
              ?.map((type) => type.name)
              .join(", ")}
          </h6>
          <P medium className={s.title}>
            {title}
          </P>
          {!hideDescription && (
            <P small className={s.description}>
              {abstract && truncate(stripHtmlFromString(abstract), 85)}
            </P>
          )}
          <div className={s.detailsWrapper}>
            <img
              src={Icons.file_text_small}
              alt="download-icon"
              className={s.downloadIcon}
            />
            <P small>{tx("document.pages", { number: numberOfPages })}</P>
            {" · "}
            <P small>{format}</P>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { cacheStore, document } = this.props;
    const { documentFields, slug, id } = document;
    const { documents } = documentFields;
    const { checkboxSelected } = cacheStore;

    return (
      <div className={s.documentDropdownItem}>
        <DropdownItem
          key={slug}
          titleItem={this.renderDocumentTitleItem()}
          selected={checkboxSelected(id)}
        >
          {documents?.map(this.renderPDFItem)}
        </DropdownItem>
        <div className={s.divider}></div>
      </div>
    );
  }
}
